export enum CreateAccountStateEnum {
	ERROR = 'ERROR',
	INVALID_EMAIL = 'INVALID_EMAIL',
	SUCCESS = 'SUCCESS'
}
